var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FA_TIMES } from '../../../const/iconProps';
import { statusColors } from '../../../defaultTheme';
import { IconWrapper, MessageBody, MessageCard, MessageCloseButton } from './subcomponents';
const MessageBox = forwardRef((_a, ref) => {
    var { icon, children, className, closeIconColor, closeHandler, type = 'info', closeButtonAriaLabel = 'Dismiss Message' } = _a, props = __rest(_a, ["icon", "children", "className", "closeIconColor", "closeHandler", "type", "closeButtonAriaLabel"]);
    return (_jsxs(MessageCard, Object.assign({ type: type, className: className, ref: ref }, props, { children: [icon && _jsx(IconWrapper, Object.assign({ type: type }, { children: icon })), closeHandler && (_jsx(MessageCloseButton, Object.assign({ buttonType: "text", onClick: closeHandler, ariaLabel: closeButtonAriaLabel }, { children: _jsx(FontAwesomeIcon, { icon: FA_TIMES, type: type, color: closeIconColor || statusColors[type].icon, size: "sm" }) }))), _jsx(MessageBody, Object.assign({ type: type }, { children: children }))] })));
});
export default MessageBox;
//# sourceMappingURL=MessageBox.js.map